var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39844 6.4002C6.39844 4.63289 7.83113 3.2002 9.59844 3.2002H16.9357C17.7844 3.2002 18.5983 3.53734 19.1984 4.13745L24.6612 9.6002C25.2613 10.2003 25.5984 11.0142 25.5984 11.8629V25.6002C25.5984 27.3675 24.1657 28.8002 22.3984 28.8002H9.59844C7.83113 28.8002 6.39844 27.3675 6.39844 25.6002V6.4002ZM9.59844 16.0002C9.59844 15.1165 10.3148 14.4002 11.1984 14.4002H20.7984C21.6821 14.4002 22.3984 15.1165 22.3984 16.0002C22.3984 16.8839 21.6821 17.6002 20.7984 17.6002H11.1984C10.3148 17.6002 9.59844 16.8839 9.59844 16.0002ZM11.1984 20.8002C10.3148 20.8002 9.59844 21.5165 9.59844 22.4002C9.59844 23.2839 10.3148 24.0002 11.1984 24.0002H20.7984C21.6821 24.0002 22.3984 23.2839 22.3984 22.4002C22.3984 21.5165 21.6821 20.8002 20.7984 20.8002H11.1984Z",
    fill: "#284254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.019ae629c8e2705a4e9633c4f3e397e0.svg";
export { ForwardRef as ReactComponent };